import z from "zod";

/**
 * CriterioAvaliacaoFornecedorSchema
 */

export const CriterioAvaliacaoFornecedorSchema = z.object({
  idCriterioAvaliacaoFornecedor: z.number(),
  descricao: z.string(),
  nota: z.number(),
  ordem: z.number(),
});

/**
 * CriterioAvaliacaoFornecedorForm
 */

export type CriterioAvaliacaoFornecedorForm = z.infer<typeof CriterioAvaliacaoFornecedorSchema>;